import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  body {
    background-color: #ecf0f5;
    margin: 0;
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, 'Source Sans Pro', 'Helvetica Neue', Helvetica,Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    min-height: 100vh;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  a {
    color: #3c8dbc;
    text-decoration: none;
    transition: color ease-in-out 100ms;

    &:hover {
      color: #72afd2
    }
  }

  p {
    margin-bottom: 0;
  }

  button {
    background-color: transparent;
    border: none;
  }

  .M1 > * {
    margin: 8px !important;
  }

  .m1 {
    margin: 8px !important;
  }

  .Mt2 > * {
    margin-top: 16px !important;
  }

  .mt2 {
    margin-top: 16px !important;
  }

  .mt3 {
    margin-top: 24px !important;
  }

  .mt4 {
    margin-top: 32px !important;
  }

  .Mb1 > * {
    margin-bottom: 8px !important;
  }

  .mb1 {
    margin-bottom: 8px !important;
  }

  .Mb2 > * {
    margin-bottom: 16px !important;
  }

  .mb2 {
    margin-bottom: 16px !important;
  }

  /* Font Color Background */
  .bg-info,
  .bg-info>a {
    color: #fff !important;
  }

  .bg-success,
  .bg-success>a {
    color: #fff !important;
  }

  .bg-primary,
  .bg-primary>a {
    color: #fff !important;
  }

  .bg-danger,
  .bg-danger>a {
    color: #fff !important;
  }

  .bg-warning,
  .bg-warning>a {
    color: #000 !important;
  }

  .bg-secondary,
  .bg-secondary>a {
    color: #000 !important;
  }
  /* End Font Color Background */

  .Toastify__toast-container {
    z-index: 9999999 !important;
  }

  .MuiBox-root.css-15k1nh5 {
    flex: none !important;
  }
`;

export default GlobalStyles;
